<template>
    <div class="import">
        <div style="display: flex; justify-content: space-between; align-items: baseline">
            <PageTitle main="Importação" sub="" />
        </div>

        <div id="pageGrid" v-show="!modalActiveArquivo">
            <div id="barraBotoes">
                <b-row>
                    <b-col cols="4" class="text-left">
                        <b-button id="btn-principal" variant="success" 
                            @click="uploadImportCSV()" size="lxg" class="mb-2 mr-2" v-if="user.imp_adi">  
                            <i class="fa fa-cloud-upload"></i> Importar CSV
                        </b-button>
                    </b-col>
                    <b-col cols="8" class="text-right">
                        <b-button id="btn-download" variant="secondary" 
                            @click="downloadLayout()" size="lgx" class="mb-2 mr-2" v-if="user.imp_adi">  
                            <i class="fa fa-cloud-download"></i> Layout CSV
                        </b-button>
                        <b-button id="btn-download" variant="secondary" 
                            @click="downloadValidador()" size="lgx" class="mb-2" v-if="user.imp_adi">  
                            <i class="fa fa-cloud-download"></i> Validador CSV
                        </b-button>
                    </b-col>
                </b-row>
            </div>           

            <b-table :items="imports" :fields="fields"
                responsive 
                borderless
                striped
                medium>
                <template slot="criado_em" slot-scope="data">
                    <span style="font-weight: 500;">{{ data.item.criado_em }}</span> <br>
                    <span style="font-size: smaller;">Usuário: {{ data.item.nm_usuario }}</span>
                </template>
                <template slot="nm_empresa" slot-scope="data">
                    <span style="font-weight: 500;">{{ data.item.nm_empresa }}</span> <br>
                    <span style="font-size: smaller;">{{ data.item.cnpj_empresa }}</span>
                </template>
                <template slot="nm_arquivo" slot-scope="data">
                    <span style="font-weight: 500;">{{ data.item.nm_arquivo }}</span> <br>
                    <span style="font-size: smaller;">Qtd Importada: {{ data.item.qtd_importada }}</span>  -  
                    <span style="font-size: smaller;">Qtd Erro: {{ data.item.qtd_erro }}</span> - 
                    <span style="font-size: smaller;">Total Registros: {{ data.item.qtd_registros }}</span>
                </template>
                <template slot="status" slot-scope="data">
                    <span style="font-weight: 500;">{{ data.item.status }}</span>
                </template>
            </b-table>
            <b-pagination class="customPagination mt-4" size="md" v-model="page" :total-rows="count" :per-page="limit" />
        </div>
     
		<div id="pageArquivo" v-show="modalActiveArquivo">
            <b-card :header="tituloModal"> 
                <b-form @submit.prevent="submit">
                    <b-row>
                        <b-col md="12" sm="12">
                            <b-form-group label="*Empresa" label-for="importacao-empresa_id">
                                <b-form-select 
                                    id="importacao-empresa_id"
                                    name="importacao-empresa_id"
                                    ref="importacao-empresa_id"
                                    :options="companies" v-model.trim="importacao.empresa_id">
                                </b-form-select>     
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="12" sm="12">
                            <b-form-group label="*Arquivo de importação .CSV">
                                <b-form-file
                                    type="file" 
                                    id="uploadFile"
                                    name="uploadFile"
                                    ref="uploadFile"
                                    accept=".csv"
                                    :maxFileSize="1024"
                                    v-model="fileCSV"
                                    :state="Boolean(fileCSV)"
                                    @change="onUploadFileChange"
                                    placeholder="Escolha um arquivo ou solte-o aqui..."
                                    drop-placeholder="Solte o arquivo aqui...">
                                </b-form-file>
                            </b-form-group>
                        </b-col>                    
                    </b-row>
                    <hr>
                    <div style="padding: 10px 0px 10px 0px; display: flex; justify-content: end;"> 
                        <b-button class="mr-2" style="width: 150px;"
                            @click="toggleModalArquivo">Cancelar
                        </b-button>  
                        <b-button variant="success" id="btn-principal" class="mr-2" style="width: 150px;"  
                            @click="uploadArquivo">Upload 
                        </b-button>
                    </div>
                </b-form>        
            </b-card>
        </div>

        <b-modal ref="modalConfirmacao" hide-footer hide-header-close no-close-on-esc no-close-on-backdrop centered title="Confirmação!">
            <p class="my-4">Deseja realmente importar este arquivo?</p>
            <template v-slot:modal-footer="{ hideConfirmacao , uploadArquivoCSVBase64 }">
                <b-row class="text-center mb-4" align-v="center" style="padding: 20px 0px 0px 0px;"> 
                    <b-col xs="12" class="mb-1">
                        <b-button id="btn-principal" variant="success" class="mr-2" style="width: 100px;"
                            @click="uploadArquivoCSVBase64()">Sim 
                        </b-button>
                        <b-button class="mr-2" style="width: 100px;"
                            @click="hideConfirmacao()">Não
                        </b-button>
                    </b-col>
                </b-row>
            </template>
        </b-modal>          
    </div>  
</template>

<script>

import { baseApiUrl, baseS3Url, showError } from '@/global'
import { mapState } from 'vuex'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
import Modal  from '../template/Modal'

export default {
    name: 'ImportNfse',
    computed: mapState(['user']),
    components: { PageTitle, Modal },

    data: function () {
        return {
            mode: 'save',
            modalActiveArquivo: false,
            tituloModal: null,

            companies: [],
            imports: [],
            importacao: {},
            fileCSV: null,
            arquivoBase64: '',
            
            fields: [
                { key: 'criado_em', label: 'Data' },
                { key: 'nm_empresa', label: 'Empresa' },
                { key: 'nm_arquivo', label: 'Arquivo' },
                { key: 'status', label: 'Status' }
            ],

            page: 1,
            count: 0,
            limit: 0,
        }
    },

    methods: {
        loadImporties() {
            axios.get(`${baseApiUrl}/importacao/nfse/empresa/${this.$store.state.user.empsuser}/pagina/${this.page}`)
                 .then(resp => {
                     //this.imports = resp.data.data
                     this.imports = resp.data.data.map(item => {
                        const parts = item.nm_empresa.split(" - ", 2);
                        if (parts.length === 2) {
                            const [cnpj_empresa, nm_empresa] = parts;
                            return {...item, cnpj_empresa, nm_empresa };
                        } else {
                            return item;
                        }
                     })
                     this.count = parseInt(resp.data.count)
                     this.limit = parseInt(resp.data.limit)
            })
        },

        loadCompanies() {
            axios.get(`${baseApiUrl}/usuario/empresas/` + this.$store.state.user.userid)  
                 .then(resp => {
                     this.companies = resp.data.data.map(campany => {
                         return { value: campany.empresa_id, text: campany.nm_empresa }
                     })
            })
        },

        uploadImportCSV() {
            this.tituloModal = 'Importação de NFS-e'
            this.toggleModalArquivo()
            setTimeout(function() { 
                document.getElementById('importacao-empresa_id').focus();
            }, 50)            
        },

        onUploadFileChange(e) {
            const selectedFile = e.target.files[0]; 
            this.createBase64File(selectedFile);
        },
        
        createBase64File(file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                this.arquivoBase64 = e.target.result;
            };
            reader.readAsDataURL(file);
        },

        uploadArquivo() {
            var emp = document.getElementById('importacao-empresa_id').value;
            if (emp == "") {
                this.$toasted.global.defaultError({ msg: 'Favor informar a empresa!'})
                document.getElementById('importacao-empresa_id').focus()
                return
            } 

            // Localiza e converte o arquivo selecionado
            var arquivo = document.getElementById('uploadFile').value;
            if (arquivo == "") {
                this.$toasted.global.defaultError({ msg: 'Favor seleciona o arquivo de importação .CSV!'})
                document.getElementById('uploadFile').focus()
                return
            } 

            // Tamanho maximo 1024 MB = 1048576 KB
            if (this.fileCSV.size > 1048576) {
                this.$toasted.global.defaultError({ msg: 'Atenção: O arquivo ultrapassa o limite de [1024 MB]'})

                this.fileCSV = null
                this.arquivoBase64 = ''
                document.getElementById('uploadFile').value = ''

                document.getElementById('uploadFile').focus()
                return
            }
            
            // Ok abre confirmação
            this.$refs.modalConfirmacao.show();
        },
        
        hideConfirmacao() { 
            this.$refs.modalConfirmacao.hide();
        },

        uploadArquivoCSVBase64() {  
            this.hideConfirmacao()

            let URL = `${baseApiUrl}/importacao/nfse/upload/empresa/${this.importacao.empresa_id}/usuario/${this.$store.state.user.userid}`

            // Payload do arquivo em Base64
            const { arquivoBase64 } = this;

            // Headers auxiliares para ajudar na geração do arquivo no lado servidor
            const headers = { 
                'Content-Type': 'application/json',
                'x-file-name': this.fileCSV.name
            }

            axios.post(URL, arquivoBase64, { headers })
                .then(resp => {
                        if (resp.data.status) {
                            this.$toasted.global.defaultSuccess({ msg: resp.data.mensagem })
                            this.importacao = {}
                            this.loadImporties()
                        } else 
                        {
                            this.$toasted.global.defaultWarning({ msg: resp.data.mensagem })
                            this.importacao = {}
                        }
                    })
                    .catch(showError) 

            this.toggleModalArquivo()
        },

        toggleModalArquivo() {
            this.modalActiveArquivo = !this.modalActiveArquivo;
            this.importacao = {}
            this.fileCSV = null
            this.arquivoBase64 = ''
            document.getElementById('uploadFile').value = ''
		},

        downloadLayout() {
            let url = `${baseS3Url}/donwloads/layout/layout-importacao-sigame.csv`        
            let arquivo = `layout-importacao-sigame.csv`     
            this.saveArquivoComo(url, arquivo)
        },  

        downloadValidador() {
            let url = `${baseS3Url}/donwloads/validador/SigameValidadorCSV.exe`        
            let arquivo = `SigameValidadorCSV.exe`     
            this.saveArquivoComo(url, arquivo)
        },  

        saveArquivoComo(url, arquivo) {
            const link = document.createElement('a')
            link.href = url
            link.download = arquivo
            document.body.appendChild(link)
            link.click()
            setTimeout(function() { 
                document.body.removeChild(link)
            }, 50)
        }       
        
    },

    watch: {
        page() {
            this.loadImporties()
        }
    },

    mounted() {
        this.loadImporties() 
        this.loadCompanies()
    }    
}

</script>

<style>
#app .import .table-responsive {
    overflow: visible
}
</style>

<style scoped>
    .title-imp {
        flex: 1;
        display: grid;
    }

    .error {
        border: 3px solid darkred;        
    }

    p {
        font-weight: 600;
        margin-bottom: 10px;
    }

    hr {
        border: 0;
        width: 100%;
        height: 1px;
        margin-top: 15px;
        margin-bottom: 20px;
        background-image: linear-gradient(to right,
            rgba(120, 120, 120, 0),
            rgba(120, 120, 120, 0.75),
            rgba(120, 120, 120, 0));
    }
    
</style>